<template>
  <div>
    <a-spin :spinning="spinning" tip="Loading...">
      <vxe-toolbar>
        <template #buttons>
          <vxe-input
            v-model="filterName_detable"
            type="search"
            placeholder="Input a key word"
            @keyup="searchEvent_detable"
          ></vxe-input>
          <vxe-button @click="exportDataEvent"
            ><a-icon type="cloud-download" /> Download</vxe-button
          >
        </template>
      </vxe-toolbar>
      <vxe-table
        border
        show-overflow
        row-id="id"
        size="small"
        :loading="loading"
        ref="xTable"
        :data="tableData_detable"
        align="center"
        class="my-sort"
        header-align="center"
        :column-config="{ isHover: true }"
        :sort-config="{
          showIcon: false,
          trigger: 'all',
        }"
        @header-cell-click="headerCellClickEvent"
      >
        <!-- <vxe-column type="expand" width="40">
          <template #content="{ row }">
            <vxe-grid
              :columns="this.childCols"
              :data="row.childData"
            ></vxe-grid>
          </template>
        </vxe-column> -->
        <vxe-column field="ID" title="Term ID" type="html"> </vxe-column>
        <vxe-column field="GeneRatio" title="Gene ratio" type="html">
        </vxe-column>
        <vxe-column field="pvalue" title="P-value" type="html" sortable>
          <template #header="{ column }">
            <span>{{ column.title }}</span>
            <span class="custom-sort" :class="{ 'is-order': column.order }">
              <i
                :class="[
                  column.order
                    ? `vxe-icon-sort-numeric-${column.order}`
                    : 'vxe-icon-sort',
                ]"
              ></i>
            </span>
          </template>
        </vxe-column>

        <vxe-column
          field="p.adjust"
          title="-Log10(Adjust p-value)"
          type="html"
          sortable
        >
          <template #header="{ column }">
            <span>{{ column.title }}</span>
            <span class="custom-sort" :class="{ 'is-order': column.order }">
              <i
                :class="[
                  column.order
                    ? `vxe-icon-sort-numeric-${column.order}`
                    : 'vxe-icon-sort',
                ]"
              ></i>
            </span> </template
        ></vxe-column>
        <template #empty>
          <span style="color: grey"> No more data! </span>
        </template>
      </vxe-table>

      <vxe-pager
        background
        size="small"
        :loading="loading_detable"
        :current-page="tablePage_detable.currentPage"
        :page-size="tablePage_detable.pageSize"
        :total="tablePage_detable.totalResult"
        :page-sizes="[10, 20, 50]"
        :layouts="[
          'PrevPage',
          'JumpNumber',
          'NextPage',
          // 'FullJump',
          'Sizes',
          'Total',
        ]"
        @page-change="handlePageChange_table"
      >
      </vxe-pager>
    </a-spin>
  </div>
</template>
<script>
import axios from "axios";
import XEUtils from "xe-utils";
// import downloadexcel from "vue-json-excel";

export default {
  props: ["resultName"],
  data() {
    return {
      //相关性分析
      childCols: [
        { type: "seq", title: "Sequence" },
        { field: "name", title: "Name" },
        { field: "role", title: "Role" },
        { field: "age", title: "Age" },
        { field: "sex", title: "Sex" },
      ],
      corModal: false,
      gene1: "",
      gene2: this.$route.query.gene,
      //加载
      spinning: true,
      loading: false,
      //全表搜索
      filterName_detable: "",
      tempdata_detable: [],
      //分页
      getdata_detable: null, //必须要生成这个data
      loading_detable: false,
      tableData_detable: [],
      tablePage_detable: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 0,
      },
    };
  },
  watch: {
    resultName() {
      axios
        .get(
          "http://research.gzsys.org.cn/perturbdb/data/upload/temp/" +
            this.resultName +
            ".json"
        )
        .then((response) => {
          this.getdata_detable = response.data.sort(
            (a, b) => b["p.adjust"] - a["p.adjust"]
          );
          this.findList_detable(this.getdata_detable);
          this.tablePage_detable.currentPage = 1; //必须重置到第一页
          this.spinning = false;
        });
    },
  },
  // created() {
  //   axios
  //     .get(
  //       "http://research.gzsys.org.cn/perturbdb/API/perturbedgene/publications_deTable.php",
  //       {
  //         params: {
  //           datasetId: this.$route.query.datasetId,
  //           gene: this.$route.query.gene,
  //         },
  //       }
  //     )
  //     .then((response) => {
  //       const convertedArray = response.data
  //         .filter((item) => {
  //           item.fc = parseFloat(item.fc).toFixed(2);
  //           item.pct1 = parseFloat(item.pct1).toFixed(2);
  //           item.pct2 = parseFloat(item.pct2).toFixed(2);
  //           item.pvalue = parseFloat(item.pvalue);
  //           item.padj = parseFloat(item.padj);
  //           return true; // 返回true以保留所有对象
  //         })
  //         .sort((a, b) => a.padj - b.padj);
  //       this.getdata_detable = convertedArray;
  //       this.findList_detable(this.getdata_detable);
  //       this.spinning = false;
  //     });
  // },

  methods: {
    headerCellClickEvent({
      column,
      triggerResizable,
      triggerSort,
      triggerFilter,
    }) {
      // 如果触发了列的其他功能按钮
      console.log(column["field"]);
      if (
        column.sortable &&
        !(triggerResizable || triggerSort || triggerFilter)
      ) {
        // this.tcgaLoading = true;
        if (column.order === "asc") {
          this.$refs.xTable.sort(column.property, "desc");
          var jiangxu = this.getdata_detable.sort(
            (a, b) => b[column.field] - a[column.field]
          ); // 按照 num 属性降序排序
          this.getdata_detable = jiangxu;
          this.findList_detable(this.getdata_detable);
          // this.tcgaLoading = false;
        } else {
          this.$refs.xTable.sort(column.property, "asc");
          //var field = column.field;
          var shengxu = this.getdata_detable.sort(
            (a, b) => a[column.field] - b[column.field]
          ); // 按照 num 属性降序排序
          this.getdata_detable = shengxu;
          this.findList_detable(this.getdata_detable);
          // this.tcgaLoading = false;
        }
      }
    },
    formatAmount({ cellValue }) {
      return XEUtils.commafy(XEUtils.toNumber(cellValue));
    },
    exportDataEvent() {
      if (this.tempdata_detable.length == 0) {
        const list = this.getdata_detable;
        this.$refs.xTable.exportData({
          filename: this.resultName + "_ORA-result-of-PGSEA",
          type: "txt",
          isHeader: true,
          isFooter: true,
          data: list,
        });
      } else {
        if (this.filterName_detable == "" || this.filterName_detable == " ") {
          const list = this.getdata_detable;
          this.$refs.xTable.exportData({
            filename: this.resultName + "_ORA-result-of-PGSEA",
            type: "txt",
            isHeader: true,
            isFooter: true,
            data: list,
          });
        } else {
          const list = this.tempdata_detable;
          this.$refs.xTable.exportData({
            filename: this.filterName_detable + "_related_ORA-result-of-PGSEA",
            type: "txt",
            isHeader: true,
            isFooter: true,
            data: list,
          });
        }
      }
    },
    handleOk() {
      this.corModal = false;
    },
    handleCancel() {
      this.corModal = false;
    },
    goPerturbgene_detable(value) {
      console.log(value);
      this.corModal = true;
      this.gene1 = value;
      // let href =
      //   "https://www.genecards.org/cgi-bin/carddisp.pl?gene=" +
      //   value +
      //   "&keywords=" +
      //   value;
      // window.open(href, "_blank");
    },
    findList_detable(data) {
      this.loading_detable = true;
      setTimeout(() => {
        const list = data;
        this.loading_detable = false;
        this.tablePage_detable.totalResult = list.length;
        this.tableData_detable = list.slice(
          (this.tablePage_detable.currentPage - 1) *
            this.tablePage_detable.pageSize,
          this.tablePage_detable.currentPage * this.tablePage_detable.pageSize
        );
      }, 300);
    },
    handlePageChange_table({ currentPage, pageSize }) {
      this.tablePage_detable.currentPage = currentPage;
      this.tablePage_detable.pageSize = pageSize;
      if (this.tempdata_detable.length == 0) {
        this.findList_detable(this.getdata_detable);
      } else {
        this.findList_detable(this.tempdata_detable);
      }
    },
    searchEvent_detable() {
      this.tablePage_detable.currentPage = 1;
      const filterName = XEUtils.toValueString(this.filterName_detable)
        .trim()
        .toLowerCase();
      if (filterName && filterName != "") {
        const filterRE = new RegExp(filterName, "gi");
        const searchProps = ["ID"];
        const rest = this.getdata_detable.filter((item) =>
          searchProps.some(
            (key) =>
              XEUtils.toValueString(item[key])
                .toLowerCase()
                .indexOf(filterName) > -1
          )
        );
        this.tempdata_detable = rest.map((row) => {
          const item = Object.assign({}, row);
          searchProps.forEach((key) => {
            item[key] = XEUtils.toValueString(item[key]).replace(
              filterRE,
              (match) => `${match}`
            );
          });
          return item;
        });
        this.findList_detable(this.tempdata_detable);
      } else {
        this.tempdata_detable = [];
        this.findList_detable(this.getdata_detable);
      }
    },
  },
};
</script>
<style scpoed>
.keyword-lighten {
  color: #000;
  background-color: #ffff00;
}
.my-sort .custom-sort {
  padding: 0 4px;
}
.my-sort .custom-sort.is-order {
  color: #409eff;
}
</style>
